import { createFileRoute, Link } from "@tanstack/react-router"
import { defaultMeta } from "@/lib/seo"

export const Route = createFileRoute(`/_public/contact`)({
  ssr: true,
  head: () =>
    defaultMeta({
      title: `Contact`,
      description: `Contact ChicTravel for support, privacy, or product questions.`,
      path: `/contact`,
    }),
  component: ContactPage,
})

function ContactPage() {
  return (
    <main className="max-w-3xl mx-auto px-6 py-16 space-y-8">
      <div className="space-y-3">
        <h1 className="text-4xl font-extrabold tracking-tight">Contact</h1>
        <p className="text-muted-foreground leading-relaxed">
          Need a hand with ChicTravel, billing, privacy, or a published guide?
          Chat with us live — no account required.
        </p>
      </div>

      <section className="rounded-lg border border-border bg-card p-6 space-y-3">
        <h2 className="text-xl font-bold">Support</h2>
        <p className="text-muted-foreground">
          Need help with planning, billing, privacy, or a published guide?{` `}
          <Link
            to="/support"
            className="font-medium text-primary hover:underline"
          >
            Start a live chat
          </Link>
          {` `}and a real person will get back to you.
        </p>
      </section>
    </main>
  )
}
